<template>
  <time :datetime="html" :title="readableDateWithTime">
    {{ dateOnly ? dateShort : dateWithTime }}
  </time>
</template>

<script lang="ts" setup>
defineProps<{
  // 31.01.2023
  dateShort: string

  // Dienstag, 31. Januar 2023 - 16:39 Uhr
  readableDateWithTime: string

  // 21.03.2023 - 11:59 Uhr
  dateWithTime: string

  // 2023-01-31T16:39:02+0100
  html: string

  // Only show date without time.
  dateOnly: boolean
}>()
</script>

<script lang="ts">
export default {
  name: 'DrupalDateTime',
}
</script>
